import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The coral hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a fresh teal + aqua reef palette pulled from her
 * painted art, with a coral-pink accent and a deep-ocean dusk sky (her own underwater world). Choosing her
 * recolours the WHOLE kid shell: the brand ramp drives buttons / meters / rings in teal, the canvas washes to a
 * cool aqua tide, and the hero stage takes her deep-sea blue-green dusk. Every brand colour is paired with its
 * own foreground for legibility.
 */
export const coralTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — teal. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light text
  // (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #1E818A for coloured shadows.
  '--color-primary': '#1E818A',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#21A3AA',
  '--color-primary-deep': '#186E78',
  '--color-primary-tint': '#DFF6F8',
  '--color-primary-glow-rgb': '30 129 138',
  '--color-secondary': '#D6F3F5',
  '--color-secondary-fg': '#12545C',
  '--color-accent': '#FF8FA3',
  '--color-accent-fg': '#5A1420',
  // CANVAS — a cool aqua bloom top-left, a soft coral-tinted bloom bottom-right (a fresh tide behind the content).
  '--canvas-a': '#DAF4F6',
  '--canvas-b': '#FDE6EA',
  // A deep sea-green ocean dusk (white text stays AA over it).
  '--sky-top': '#0d3a44',
  '--sky-mid': '#1a6b78',
  '--sky-low': '#68c3cf',
  '--sky-glow': '#ffd6de',
  '--sky-fg': '#ffffff',
});
